import { clowncar } from 'types';
import { payloadToJSON } from '@tock/coretypes';
import ClowncarAppConstants from 'constants/ClowncarAppConstants';

interface State {
  isInitialized: boolean;
  achTransferRequest?: clowncar.ManualAchRequest;
}

const initialState: State = {
  isInitialized: false,
  achTransferRequest: undefined,
};

export default function reducer(state: State = initialState, action: BaseTockAction) {
  const { type, payload } = action;
  switch (type) {
    case ClowncarAppConstants.BANK_TRANSFER_FETCH_DONE: {
      return {
        isInitialized: true,
        achTransferRequest: payloadToJSON<clowncar.ManualAchRequest>(payload),
      };
    }
    default:
      return state;
  }
}
